import React, { useState } from "react";
import { Card } from "../card";
import InputField from "../input/inputField";
import { SectionHeader } from "../Header/SectionHeader";
import { ParentInfo } from "../../Models/parents.models";
import { BtnType, Button } from "../Button";
import { ParentsInfo } from "../../Redux/Slices/studentAdmission.slice";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
  setWarningMessage,
} from "../../Redux/Slices/alert.slice";
import { SOMETHING_WENT_WRONG } from "../../Constants/messages";
import { useUpdateStudentsParentInfo } from "../../hooks/students/useUpdateStudent.hooks";
import { UpdateStudentParentInfoInterface } from "../../Constants/Interfaces/payloadInterface/StudentPayload.interface";

import {
  FATHER_MOBILE_REQUIRED,
  FATHER_NAME_REQUIRED,
  MOTHER_MOBILE_REQUIRED,
  MOTHER_NAME_REQUIRED,
} from "../../Constants/Message/Parent.messages";
interface Props {
  fatherInfo: ParentsInfo;
  motherInfo: ParentInfo;
  studentId: number;
}
export const StudentParentInfo = ({
  motherInfo,
  fatherInfo,
  studentId,
}: Props) => {
  const dispatch = useDispatch();
  const [_motherInfo, setMotherInfo] = useState<ParentInfo>(motherInfo);

  const [_fatherInfo, setFatherInfo] = useState<ParentInfo>(fatherInfo);

  const { isLoading: isUpdatingParentInfo, mutate: updateParentInfo } =
    useUpdateStudentsParentInfo({
      studentId,
    });

  const validateParentInfo = () => {
    if (!_motherInfo.name) {
      dispatch(setWarningMessage(MOTHER_NAME_REQUIRED));
      return false;
    }
    if (!_motherInfo.mobile) {
      dispatch(setWarningMessage(MOTHER_MOBILE_REQUIRED));
      return false;
    }
    if (!_fatherInfo.name) {
      dispatch(setWarningMessage(FATHER_NAME_REQUIRED));
      return false;
    }
    if (!_fatherInfo.mobile) {
      dispatch(setWarningMessage(FATHER_MOBILE_REQUIRED));
      return false;
    }

    return true;
  };

  const onParentInfoUpdate = () => {
    if (!validateParentInfo()) {
      return;
    }

    updateParentInfo(
      {
        motherInfo: _motherInfo,
        fatherInfo: _fatherInfo,
      } as UpdateStudentParentInfoInterface,
      {
        onSuccess: () => {
          dispatch(
            setSuccessMessage("Parent info has been successfully updated.")
          );
        },
        onError: (error: any) => {
          dispatch(
            setErrorMessage(error.response.data.message || SOMETHING_WENT_WRONG)
          );
        },
      }
    );
  };

  return (
    <Card>
      <div className="w-full flex flex-row gap-24">
        {/* MOTHER INFO */}
        <div className="flex flex-col gap-6 w-full">
          <SectionHeader headerText="Mother info" />
          <InputField
            value={_motherInfo?.name || ""}
            setValue={(value) => {
              setMotherInfo({
                ..._motherInfo,
                name: value,
              });
            }}
            label="Mother's name"
          />
          <InputField
            value={_motherInfo?.occupation || ""}
            setValue={(value) => {
              setMotherInfo({
                ..._motherInfo,
                occupation: value,
              });
            }}
            label="Mother's occupation"
          />
          <InputField
            value={_motherInfo?.mobile || ""}
            setValue={(value) => {
              setMotherInfo({
                ..._motherInfo,
                mobile: value,
              });
            }}
            label="Mother's mobile"
          />
        </div>
        {/* FATHER INFO */}
        <div className="flex flex-col gap-6 w-full">
          <SectionHeader headerText="Father info" />
          <InputField
            value={_fatherInfo?.name || ""}
            setValue={(value) => {
              setFatherInfo({
                ...fatherInfo,
                name: value,
              });
            }}
            label="Father's name"
          />
          <InputField
            value={_fatherInfo?.occupation || ""}
            setValue={(value) => {
              setFatherInfo({
                ...fatherInfo,
                occupation: value,
              });
            }}
            label="Father's occupation"
          />
          <InputField
            value={_fatherInfo?.mobile || ""}
            setValue={(value) => {
              setFatherInfo({
                ...fatherInfo,
                mobile: value,
              });
            }}
            label="father's mobile"
          />
        </div>
      </div>
      <div className="mt-12">
        <Button
          btnType={BtnType.primary}
          text="Save"
          loading={isUpdatingParentInfo}
          onClick={onParentInfoUpdate}
        />
      </div>
    </Card>
  );
};
